//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { CreatorListSort } from '@influencers/components/CreatorTableSort';
import { IInfluencerBulkAddStatusCode } from '@influencers/models/influencersApiModel';
import { IInfluencersBulkAddStatus } from '@influencers/models/influencersStateModel';
import { SocialNetwork } from '@models/SocialNetwork';
import { TrackingId } from '@models/TrackingId';

const influencersPrefix = 'influencers-';

export const InfluencersTrackingIds = {
  CREATOR_DETAILS_HEADER_BIO_ADD_CREATORS_TO_LISTS_ADD_BUTTON: `${influencersPrefix}creator-details-header-bio-add-creators-to-lists-add-button`,
  CREATOR_DETAILS_HEADER_BIO_ADD_CREATORS_TO_LISTS_CREATE_LIST_BUTTON: `${influencersPrefix}creator-details-header-bio-add-creators-to-lists-create-list-button`,
  CREATOR_DETAILS_HEADER_BIO_ADD_CREATORS_TO_LISTS_DONE_BUTTON: `${influencersPrefix}creator-details-header-bio-add-creators-to-lists-done-button`,
  CREATOR_DETAILS_HEADER_BIO_ADD_CREATORS_TO_LISTS_NEW_LIST_INPUT: `${influencersPrefix}creator-details-header-bio-add-creators-to-lists-new-list-input`,
  CREATOR_DETAILS_HEADER_BIO_ADD_TO_LIST_BUTTON: `${influencersPrefix}creator-details-header-bio-add-to-list-button`,
  CREATOR_DETAILS_HEADER_BIO_CREATOR_BRAND_SAFETY_CATEGORY_POSTS_PREFIX: `${influencersPrefix}creator-details-header-bio-creator-brand-safety-category-posts-`,
  CREATOR_DETAILS_HEADER_BIO_CREATOR_BRAND_SAFETY_SHOW_MORE_BUTTON: `${influencersPrefix}creator-details-header-bio-creator-brand-safety-show-more-button`,
  CREATOR_DETAILS_HEADER_BIO_CREATOR_LISTS_LINK: `${influencersPrefix}creator-details-header-bio-creator-lists-link`,
  CREATOR_DETAILS_HEADER_BIO_EMAIL_LINK: `${influencersPrefix}creator-details-header-bio-email-link`,
  CREATOR_DETAILS_HEADER_BIO_MORE_ACTIONS_ADD_TO_COLLECTION_BUTTON: `${influencersPrefix}creator-details-header-bio-more-actions-add-to-collection-button`,
  CREATOR_DETAILS_HEADER_BIO_MORE_ACTIONS_CONFIGURE_RIGHTS_SETTINGS_BUTTON: `${influencersPrefix}creator-details-header-bio-more-actions-configure-rights-settings-button`,
  CREATOR_DETAILS_HEADER_BIO_MORE_ACTIONS_DELETE_CREATOR_BUTTON: `${influencersPrefix}creator-details-header-bio-more-actions-delete-creator-button`,
  CREATOR_DETAILS_HEADER_BIO_MORE_ACTIONS_DELETE_CREATOR_MODAL_BUTTON: `${influencersPrefix}creator-details-header-bio-more-actions-delete-creator-modal-button`,
  CREATOR_DETAILS_HEADER_BIO_MORE_ACTIONS_EXPORT_BUTTON: `${influencersPrefix}creator-details-header-bio-more-actions-export-button`,
  CREATOR_DETAILS_HEADER_BIO_MORE_ACTIONS_SAVE_RIGHTS_SETTINGS_BUTTON: `${influencersPrefix}creator-details-header-bio-more-actions-save-rights-settings-button`,
  CREATOR_DETAILS_HEADER_BIO_MORE_ACTIONS_TRACK_CREATOR_BUTTON: `${influencersPrefix}creator-details-header-bio-more-actions-track-creator-button`,
  CREATOR_DETAILS_HEADER_BIO_MORE_ACTIONS_VIEW_ON_INSTAGRAM_BUTTON: `${influencersPrefix}creator-details-header-bio-more-actions-view-on-instagram-button`,
  CREATOR_DETAILS_HEADER_BIO_PHONE_LINK: `${influencersPrefix}creator-details-header-bio-phone-link`,
  CREATOR_DETAILS_HEADER_BIO_PREFIX: `${influencersPrefix}creator-details-header-bio-`,
  CREATOR_DETAILS_HEADER_BIO_SOCIAL_ACCOUNTS_FACEBOOK_LINK: `${influencersPrefix}creator-details-header-bio-social-accounts-facebook-link`,
  CREATOR_DETAILS_HEADER_BIO_SOCIAL_ACCOUNTS_INSTAGRAM_LINK: `${influencersPrefix}creator-details-header-bio-social-accounts-instagram-link`,
  CREATOR_DETAILS_HEADER_BIO_SOCIAL_ACCOUNTS_TIKTOK_LINK: `${influencersPrefix}creator-details-header-bio-social-accounts-tiktok-link`,
  CREATOR_DETAILS_HEADER_BIO_SOCIAL_ACCOUNTS_TWITTER_LINK: `${influencersPrefix}creator-details-header-bio-social-accounts-twitter-link`,
  CREATOR_DETAILS_HEADER_BIO_SOCIAL_ACCOUNTS_YOUTUBE_LINK: `${influencersPrefix}creator-details-header-bio-social-accounts-youtube-link`,
  CREATOR_DETAILS_HEADER_USERNAME: `${influencersPrefix}creator-details-header-username`,
  CREATOR_DETAILS_INSIGHTS_BRAND_AFFINITY_BRAND_LINK: `${influencersPrefix}creator-details-insights-brand-affinity-brand-link`,
  CREATOR_DETAILS_INSIGHTS_BRAND_AFFINITY_MEDIA_CHEVRON_BUTTON: `${influencersPrefix}creator-details-insights-brand-affinity-media-cheveron-button`,
  CREATOR_DETAILS_INSIGHTS_BRAND_AFFINITY_MEDIA_IMAGE: `${influencersPrefix}creator-details-insights-brand-affinity-media-image`,
  CREATOR_DETAILS_INSIGHTS_BRAND_AFFINITY_SEARCH_BAR_PREFIX: `${influencersPrefix}creator-details-insights-brand-affinity-search-bar-`,
  CREATOR_DETAILS_INSIGHTS_BRAND_AFFINITY_SORT_ALPHABETICAL: `${influencersPrefix}creator-details-insights-brand-affinity-sort-alphabetical`,
  CREATOR_DETAILS_INSIGHTS_BRAND_AFFINITY_SORT_FREQUENCY: `${influencersPrefix}creator-details-insights-brand-affinity-sort-frequency`,
  CREATOR_DETAILS_INSIGHTS_BRAND_AFFINITY_SORT_RECENCY: `${influencersPrefix}creator-details-insights-brand-affinity-sort-recency`,
  CREATOR_DETAILS_INSIGHTS_BRAND_AFFINITY_SPONSORED_CHECKBOX: `${influencersPrefix}creator-details-insights-brand-affinity-sponsored-checkbox`,
  CREATOR_DETAILS_INSIGHTS_CONTENT_DISTRIBUTION_SELECT_MONTH: `${influencersPrefix}creator-details-insights-content-distribution-select-month`,
  CREATOR_DETAILS_INSIGHTS_CONTENT_DISTRIBUTION_SELECT_THREEMONTHS: `${influencersPrefix}creator-details-insights-content-distribution-select-threemonths`,
  CREATOR_DETAILS_INSIGHTS_CONTENT_DISTRIBUTION_SELECT_WEEK: `${influencersPrefix}creator-details-insights-content-distribution-select-week`,
  CREATOR_DETAILS_INSIGHTS_COPY_INVITE_LINK_BUTTON: `${influencersPrefix}creator-details-insights-copy-invite-link-button`,
  CREATOR_DETAILS_INSIGHTS_FOLLOWERS_BY_AGE_ALL_BUTTON: `${influencersPrefix}creator-details-insights-followers-by-age-all-button`,
  CREATOR_DETAILS_INSIGHTS_FOLLOWERS_BY_AGE_FEMALE_BUTTON: `${influencersPrefix}creator-details-insights-followers-by-age-female-button`,
  CREATOR_DETAILS_INSIGHTS_FOLLOWERS_BY_AGE_MALE_BUTTON: `${influencersPrefix}creator-details-insights-followers-by-age-male-button`,
  CREATOR_DETAILS_INSIGHTS_FOLLOWERS_BY_AGE_UNSPECIFIED_BUTTON: `${influencersPrefix}creator-details-insights-followers-by-age-unspecified-button`,
  CREATOR_DETAILS_INSIGHTS_FOLLOWERS_BY_LOCATION_CITIES_BUTTON: `${influencersPrefix}creator-details-insights-followers-by-location-cities-button`,
  CREATOR_DETAILS_INSIGHTS_FOLLOWERS_BY_LOCATION_COUNTRIES_BUTTON: `${influencersPrefix}creator-details-insights-followers-by-location-countries-button`,
  CREATOR_DETAILS_INSIGHTS_REQUEST_AUDIENCE_ESTIMATES_BUTTON: `${influencersPrefix}creator-details-insights-request-audience-estimates-button`,
  CREATOR_DETAILS_MEDIA_DATE_RANGE_PICKER: `${influencersPrefix}creator-details-media-date-range-picker`,
  CREATOR_DETAILS_MEDIA_INSIGHTS_BUTTON: `${influencersPrefix}creator-details-media-insights-button`,
  CREATOR_DETAILS_MEDIA_INSTAGRAM_ACCOUNT_CONNECTION_LINK: `${influencersPrefix}creator-details-media-instagram-account-link`,
  CREATOR_DETAILS_MEDIA_MENTIONS_CHECKBOX: `${influencersPrefix}creator-details-media-mentions-checkbox`,
  CREATOR_DETAILS_MEDIA_SEARCH_BAR: `${influencersPrefix}creator-details-media-search-bar`,
  CREATOR_DETAILS_MEDIA_SORT_COMMENTS: `${influencersPrefix}creator-details-media-sort-comments`,
  CREATOR_DETAILS_MEDIA_SORT_EMV: `${influencersPrefix}creator-details-media-sort-emv`,
  CREATOR_DETAILS_MEDIA_SORT_ENGAGEMENT_RATE: `${influencersPrefix}creator-details-media-sort-engagement-rate`,
  CREATOR_DETAILS_MEDIA_SORT_LIKES: `${influencersPrefix}creator-details-media-sort-likes`,
  CREATOR_DETAILS_MEDIA_SORT_TIME: `${influencersPrefix}creator-details-media-sort-time`,
  CREATOR_DETAILS_PROFILE_UPDATE_BUTTON: `${influencersPrefix}creator-details-profile-update-button`,
  CREATOR_DETAILS_SIDEBAR_BACK_LINK: `${influencersPrefix}creator-details-sidebar-back-link`,
  CREATOR_DETAILS_SIMILAR_CREATOR_PREFIX: `${influencersPrefix}creator-details-similar-creator-`,
  CREATOR_DETAILS_SIMILAR_CREATOR_USERNAME_LINK: `${influencersPrefix}creator-details-similar-creator-username-link`,
  CREATOR_DETAILS_SIMILAR_CREATORS_OPEN_HARMONY_AI: `${influencersPrefix}creator-details-similar-creator-open-harmony-ai`,
  CREATOR_LISTS_ADD_CREATORS_TO_CAMPAIGN_ADD_BUTTON: `${influencersPrefix}creator-lists-add-creators-to-campaign-add-button`,
  CREATOR_LISTS_ADD_CREATORS_TO_CAMPAIGN_DONE_BUTTON: `${influencersPrefix}creator-lists-add-creators-to-campaign-done-button`,
  CREATOR_LISTS_ADD_CREATORS_TO_CAMPAIGN_FIND_CAMPAIGN_INPUT: `${influencersPrefix}creator-lists-add-creators-to-campaign-find-campaign-input`,
  CREATOR_LISTS_ADD_CREATORS_TO_CAMPAIGN_ITEM: `${influencersPrefix}creator-lists-add-creators-to-campaign-item`,
  CREATOR_LISTS_ADD_TO_ANOTHER_LIST: `${influencersPrefix}creator-lists-add-to-another-list-menu-item`,
  CREATOR_LISTS_ADD_TO_CAMPAIGN: `${influencersPrefix}creator-lists-add-to-campaign-menu-item`,
  CREATOR_LISTS_BULK_ADD_CREATORS_BUTTON: `${influencersPrefix}creator-lists-bulk-add-creators-button`,
  CREATOR_LISTS_BULK_ADD_MODAL_ADD_BUTTON: `${influencersPrefix}creator-lists-bulk-add-modal-add-button`,
  CREATOR_LISTS_BULK_ADD_MODAL_DONE_BUTTON: `${influencersPrefix}creator-lists-bulk-add-modal-done-button`,
  CREATOR_LISTS_BULK_ADD_MODAL_RESULT_REGISTRATION_ALERT: `${influencersPrefix}creator-lists-bulk-add-modal-result-registration-alert`,
  CREATOR_LISTS_BULK_ADD_USERS_DROPDOWN: `${influencersPrefix}creator-lists-bulk-add-users-dropdown`,
  CREATOR_LISTS_BULK_ADD_USERS_INPUT: `${influencersPrefix}creator-lists-bulk-add-users-input`,
  CREATOR_LISTS_CREATE_LIST_INPUT: `${influencersPrefix}creator-lists-create-list-input`,
  CREATOR_LISTS_CREATE_LIST_MODAL: `${influencersPrefix}creator-lists-create-list-modal`,
  CREATOR_LISTS_CREATOR_ROW_MORE_ACTIONS_BUTTON: `${influencersPrefix}creator-lists-creator-row-more-actions-button`,
  CREATOR_LISTS_HEADER_MORE_ACTIONS_ALL_MEDIA_RIGHTS_RADIO_ITEM: `${influencersPrefix}creator-lists-header-more-actions-all-media-rights-radio-item`,
  CREATOR_LISTS_HEADER_MORE_ACTIONS_BUTTON: `${influencersPrefix}creator-lists-header-more-actions-button`,
  CREATOR_LISTS_HEADER_MORE_ACTIONS_CONFIGURE_RIGHTS_BUTTON: `${influencersPrefix}lists-more-actions-configure-rights-button`,
  CREATOR_LISTS_HEADER_MORE_ACTIONS_DEFAULT_RIGHTS_RADIO_ITEM: `${influencersPrefix}creator-lists-header-more-actions-default-rights-radio-item`,
  CREATOR_LISTS_HEADER_MORE_ACTIONS_DELETE_LIST_BUTTON: `${influencersPrefix}lists-more-actions-delete-list-button`,
  CREATOR_LISTS_HEADER_MORE_ACTIONS_DELETE_LIST_MODAL_BUTTON: `${influencersPrefix}creator-lists-header-more-actions-delete-list-modal-button`,
  CREATOR_LISTS_HEADER_MORE_ACTIONS_DOWNLOAD_LIST_BUTTON: `${influencersPrefix}lists-more-actions-download-list-button`,
  CREATOR_LISTS_HEADER_MORE_ACTIONS_MENTIONED_AND_TAGGED_RIGHTS_RADIO_ITEM: `${influencersPrefix}creator-lists-header-more-actions-mentioned-and-taggedrights-radio-item`,
  CREATOR_LISTS_HEADER_MORE_ACTIONS_SAVE_RIGHTS_MODAL_BUTTON: `${influencersPrefix}creator-lists-header-more-actions-save-rights-modal-button`,
  CREATOR_LISTS_MEDIA_DATE_RANGE_PICKER: `${influencersPrefix}creator-lists-media-date-range-picker`,
  CREATOR_LISTS_MEDIA_FILTER_PLATFORMS_ALL: `${influencersPrefix}creator-lists-media-filter-platforms-all`,
  CREATOR_LISTS_MEDIA_FILTER_PLATFORMS_INSTAGRAM: `${influencersPrefix}creator-lists-media-filter-platforms-instagram`,
  CREATOR_LISTS_MEDIA_FILTER_PLATFORMS_TIKTOK: `${influencersPrefix}creator-lists-media-filter-platforms-tiktok`,
  CREATOR_LISTS_MEDIA_MENTIONS_CHECKBOX: `${influencersPrefix}creator-lists-media-mentions-checkbox`,
  CREATOR_LISTS_MEDIA_SEARCH_BAR: `${influencersPrefix}creator-lists-media-search-bar`,
  CREATOR_LISTS_MEDIA_SORT_COMMENTS: `${influencersPrefix}creator-lists-media-sort-comments`,
  CREATOR_LISTS_MEDIA_SORT_EMV: `${influencersPrefix}creator-lists-media-sort-emv`,
  CREATOR_LISTS_MEDIA_SORT_ENGAGEMENT_RATE: `${influencersPrefix}creator-lists-media-sort-engagement-rate`,
  CREATOR_LISTS_MEDIA_SORT_LIKES: `${influencersPrefix}creator-lists-media-sort-likes`,
  CREATOR_LISTS_MEDIA_SORT_TIME: `${influencersPrefix}creator-lists-media-sort-time`,
  CREATOR_LISTS_MORE_ACTIONS_BUTTON: `${influencersPrefix}creator-lists-more-actions-button`,
  CREATOR_LISTS_PREFIX: `${influencersPrefix}creator-lists-`,
  CREATOR_LISTS_REMOVE_FROM_LIST: `${influencersPrefix}creator-lists-remove-from-list-menu-item`,
  CREATOR_LISTS_SELECTED_CREATORS_CONTAINER_REMOVE_CREATOR_BUTTON: `${influencersPrefix}creator-lists-selected-creators-container-remove-creator-button`,
  CREATOR_LISTS_SELECT_ALL_USERS_TO_ADD_TO_LIST_CHECKBOX: `${influencersPrefix}creator-lists-select-all-users-to-add-to-list-checkbox`,
  CREATOR_LISTS_SELECT_USER_TO_ADD_TO_LIST_CHECKBOX: `${influencersPrefix}creator-lists-select-user-to-add-to-list-checkbox`,
  CREATOR_LISTS_USERS_FILTER_PLATFORMS_ALL: `${influencersPrefix}creator-lists-users-filter-platforms-all`,
  CREATOR_LISTS_USERS_FILTER_PLATFORMS_INSTAGRAM: `${influencersPrefix}creator-lists-users-filter-platforms-instagram`,
  CREATOR_LISTS_USERS_FILTER_PLATFORMS_TIKTOK: `${influencersPrefix}creator-lists-users-filter-platforms-tiktok`,
  CREATOR_LISTS_USERS_FILTER_PLATFORMS_YOUTUBE: `${influencersPrefix}creator-lists-users-filter-platforms-youtube`,
  CREATOR_LISTS_USERS_SEARCH_BAR: `${influencersPrefix}creator-lists-users-search-bar`,
  CREATOR_LISTS_USERS_SORT_DROPDOWN: `${influencersPrefix}creator-lists-users-sort-dropdown`,
  CREATOR_LISTS_USERS_TABLE_HEADER_SORT_AVG_EMV: `${influencersPrefix}creator-lists-users-table-header-sort-average-emv`,
  CREATOR_LISTS_USERS_TABLE_HEADER_SORT_ENGAGEMENT_RATE: `${influencersPrefix}creator-lists-users-table-header-sort-engagement-rate`,
  CREATOR_LISTS_USERS_TABLE_HEADER_SORT_FOLLOWERS: `${influencersPrefix}creator-lists-users-table-header-sort-followers`,
  CREATOR_LISTS_USERS_TABLE_HEADER_SORT_POSTS_FT_BRAND: `${influencersPrefix}creator-lists-users-table-header-sort-posts-ft-brand`,
  HARMONY_AI_ADDITIONAL_FILTERS_CONTACT_INFO_AVAILABLE: `${influencersPrefix}harmony-ai-additional-filters-contact-info-available`,
  HARMONY_AI_ADDITIONAL_FILTERS_DROPDOWN: `${influencersPrefix}harmony-ai-additional-filters-dropdown`,
  HARMONY_AI_ADDITIONAL_FILTERS_EXCLUDE_SAVED_CREATORS: `${influencersPrefix}harmony-ai-additional-filters-exclude-saved-creators`,
  HARMONY_AI_ADDITIONAL_FILTERS_EXCLUDE_TRACKED_CREATORS: `${influencersPrefix}harmony-ai-additional-filters-exclude-tracked-creators`,
  HARMONY_AI_AGE_RANGE_FILTER_APPLY: `${influencersPrefix}harmony-ai-age-range-filter-apply`,
  HARMONY_AI_AGE_RANGE_FILTER_DROPDOWN: `${influencersPrefix}harmony-ai-age-range-filter-dropdown`,
  HARMONY_AI_BIOGRAPHY_FILTER_APPLY: `${influencersPrefix}harmony-ai-biography-filter-apply`,
  HARMONY_AI_BIOGRAPHY_FILTER_DROPDOWN: `${influencersPrefix}harmony-ai-biography-filter-dropdown`,
  HARMONY_AI_BRANDS_FILTER_APPLY: `${influencersPrefix}harmony-ai-brand-filter-apply`,
  HARMONY_AI_BRANDS_FILTER_DROPDOWN: `${influencersPrefix}harmony-ai-brand-filter-dropdown`,
  HARMONY_AI_ENG_RATE_FILTER_APPLY: `${influencersPrefix}harmony-ai-engagement-rate-filter-apply`,
  HARMONY_AI_ENG_RATE_FILTER_DROPDOWN: `${influencersPrefix}harmony-ai-engagement-rate-filter-dropdown`,
  HARMONY_AI_EXCLUDE_SAVED_CREATORS_FILTER: `${influencersPrefix}harmony-ai-exclude-saved-creators-filter`,
  HARMONY_AI_FILTERS_BRANDS_TYPEAHEAD: `${influencersPrefix}harmony-ai-filters-brands-typeahead`,
  HARMONY_AI_FILTERS_LANGUAGES_TYPEAHEAD: `${influencersPrefix}harmony-ai-filters-languages-typeahead`,
  HARMONY_AI_FILTERS_LOCATIONS_TYPEAHEAD: `${influencersPrefix}harmony-ai-filters-locations-typeahead`,
  HARMONY_AI_FILTERS_LOOKALIKES_TYPEAHEAD: `${influencersPrefix}harmony-ai-filters-lookalikes-typeahead`,
  HARMONY_AI_FOLLOWER_COUNT_FILTER_APPLY: `${influencersPrefix}harmony-ai-follower-count-filter-apply`,
  HARMONY_AI_FOLLOWER_COUNT_FILTER_DROPDOWN: `${influencersPrefix}harmony-ai-follower-count-filter-dropdown`,
  HARMONY_AI_FOLLOWER_COUNT_FILTER_MAX_INPUT: `${influencersPrefix}harmony-ai-follower-count-filter-max-input`,
  HARMONY_AI_FOLLOWER_COUNT_FILTER_MIN_INPUT: `${influencersPrefix}harmony-ai-follower-count-filter-min-input`,
  HARMONY_AI_GENDER_FILTER_DROPDOWN: `${influencersPrefix}harmony-ai-gender-filter-dropdown`,
  HARMONY_AI_GENDER_FILTER_FEMALE: `${influencersPrefix}harmony-ai-gender-filter-female`,
  HARMONY_AI_GENDER_FILTER_MALE: `${influencersPrefix}harmony-ai-gender-filter-male`,
  HARMONY_AI_HEADER_ADD_TO_LISTS_BUTTON: `${influencersPrefix}harmony-ai-header-add-to-lists-button`,
  HARMONY_AI_LANGUAGES_FILTER_APPLY: `${influencersPrefix}harmony-ai-language-filter-apply`,
  HARMONY_AI_LANGUAGES_FILTER_DROPDOWN: `${influencersPrefix}harmony-ai-language-filter-dropdown`,
  HARMONY_AI_LAST_POSTED_AT_FILTER_DROPDOWN: `${influencersPrefix}harmony-ai-last-posted-at-filter-dropdown`,
  HARMONY_AI_LAST_POSTED_AT_FILTER_DROPDOWN_OPTION: `${influencersPrefix}harmony-ai-last-posted-at-filter-dropdown-option`,
  HARMONY_AI_LOCATIONS_FILTER_APPLY: `${influencersPrefix}harmony-ai-location-filter-apply`,
  HARMONY_AI_LOCATIONS_FILTER_DROPDOWN: `${influencersPrefix}harmony-ai-location-filter-dropdown`,
  HARMONY_AI_LOOKALIKES_FILTER_APPLY: `${influencersPrefix}harmony-ai-lookalikes-filter-apply`,
  HARMONY_AI_LOOKALIKES_FILTER_DROPDOWN: `${influencersPrefix}harmony-ai-lookalikes-filter-dropdown`,
  HARMONY_AI_PLATFORM_FILTER_DROPDOWN: `${influencersPrefix}harmony-ai-platform-filter-dropdown`,
  HARMONY_AI_PLATFORM_FILTER_INSTAGRAM: `${influencersPrefix}harmony-ai-platform-filter-instagram`,
  HARMONY_AI_PLATFORM_FILTER_TIKTOK: `${influencersPrefix}harmony-ai-platform-filter-tiktok`,
  HARMONY_AI_PLATFORM_FILTER_YOUTUBE: `${influencersPrefix}harmony-ai-platform-filter-youtube`,
  HARMONY_AI_PREFIX: `${influencersPrefix}harmony-ai-`,
  HARMONY_AI_SEMANTIC_SEARCH_ADD_IMAGE_BUTTON: `${influencersPrefix}harmony-ai-semantic-search-add-image-button`,
  HARMONY_AI_SEMANTIC_SEARCH_HISTORY_BUTTON: `${influencersPrefix}harmony-ai-semantic-search-history-button`,
  HARMONY_AI_SEMANTIC_SEARCH_NO_RESULTS_NEW_SEARCH_BUTTON: `${influencersPrefix}harmony-ai-semantic-search-no-results-new-search-button`,
  HARMONY_AI_SEMANTIC_SEARCH_QUERY_ERROR_NEW_SEARCH_BUTTON: `${influencersPrefix}harmony-ai-semantic-search-query-error-new-search-button`,
  HARMONY_AI_SEMANTIC_SEARCH_REMOVE_IMAGE_BUTTON: `${influencersPrefix}harmony-ai-semantic-search-remove-image-button`,
  HARMONY_AI_SEMANTIC_SEARCH_RESULTS_CREATOR_USERNAME_LINK: `${influencersPrefix}harmony-ai-semantic-search-results-creator-username-link`,
  HARMONY_AI_SEMANTIC_SEARCH_RESULTS_FIND_SIMILAR_BUTTON: `${influencersPrefix}harmony-ai-semantic-search-results-find-similar-button`,
  HARMONY_AI_SEMANTIC_SEARCH_RESULTS_QUERY_EDIT_BUTTON: `${influencersPrefix}harmony-ai-semantic-search-results-query-edit-button`,
  HARMONY_AI_SEMANTIC_SEARCH_RESULTS_QUERY_RESET_BUTTON: `${influencersPrefix}harmony-ai-semantic-search-results-query-reset-button`,
  HARMONY_AI_SEMANTIC_SEARCH_RESULTS_SELECT_CREATOR_CHECKBOX: `${influencersPrefix}harmony-ai-semantic-search-results-select-creator-checkbox`,
  HARMONY_AI_SEMANTIC_SEARCH_SUBMIT_BUTTON: `${influencersPrefix}harmony-ai-semantic-search-submit-button`,
  HARMONY_AI_SEMANTIC_SEARCH_TEXT_INPUT: `${influencersPrefix}harmony-ai-semantic-search-text-input`,
  HARMONY_AI_SIDEBAR_LINK: `${influencersPrefix}harmony-ai-sidebar-link`,
  HARMONY_AI_SOURCE_FILTER_BAZAARVOICE: `${influencersPrefix}harmony-ai-source-filter-bazaarvoice`,
  HARMONY_AI_SOURCE_FILTER_DROPDOWN: `${influencersPrefix}harmony-ai-source-filter-dropdown`,
  HARMONY_AI_SOURCE_FILTER_INFLUENSTER_PRO: `${influencersPrefix}harmony-ai-source-filter-influensterPro`,
  HARMONY_AI_TOGGLE_EXCLUDED_FILTERS_SHOW_MORE: `${influencersPrefix}harmony-ai-toggle-excluded-filters-show-more`,
  HARMONY_AI_TOGGLE_INCLUDED_FILTERS_SHOW_MORE: `${influencersPrefix}harmony-ai-toggle-included-filters-show-more`,
  INFLUENCERS_CARD_USERNAME_LINK: `${influencersPrefix}card-username-link`,
  INFLUENCERS_LIST_DELETE_USERS_MODAL_BUTTON: `${influencersPrefix}list-delete-users-modal-button`,
  MANAGE_TRACKED_INFLUENCERS_BULK_ADD_LINK: `${influencersPrefix}manage-tracked-influencers-bulk-add-link`,
} as const satisfies Record<string, TrackingId>;

export enum INFLUENCERS_SEARCH_ACTIONS {
  UPDATE_ADD_SEARCH_TERMS = 'INFLUENCERS/UPDATE_ADD_SEARCH_TERMS',
  REQUEST_SEARCH_RESULTS = 'INFLUENCERS/REQUEST_SEARCH_RESULTS',
  RECEIVE_SEARCH_RESULTS = 'INFLUENCERS/RECEIVE_SEARCH_RESULTS',
  UPDATE_REMOVE_SEARCH_TERM_BY_INDEX = 'INFLUENCERS/UPDATE_REMOVE_SEARCH_TERM_BY_INDEX',
  CLEAR_SEARCH = 'INFLUENCERS/CLEAR_SEARCH',
  CLEAR_SUGGESTED_INFLUENCERS = 'INFLUENCERS/CLEAR_SUGGESTED_INFLUENCERS',
  UPDATE_SEARCH_INPUT = 'INFLUENCERS/UPDATE_SEARCH_INPUT',
  SEARCH_INFLUENCERS_REQUESTED = 'INFLUENCERS/SEARCH_INFLUENCERS_REQUESTED',
  SEARCH_INFLUENCERS_SUCCEEDED = 'INFLUENCERS/SEARCH_INFLUENCERS_SUCCEEDED',
  SEARCH_INFLUENCERS_FAILED = 'INFLUENCERS/SEARCH_INFLUENCERS_FAILED',
  SUGGESTED_INFLUENCERS_REQUESTED = 'INFLUENCERS/SUGGESTED_INFLUENCERS_REQUESTED',
  SUGGESTED_INFLUENCERS_SUCCEEDED = 'INFLUENCERS/SUGGESTED_INFLUENCERS_SUCCEEDED',
  SUGGESTED_INFLUENCERS_FAILED = 'INFLUENCERS/SUGGESTED_INFLUENCERS_FAILED',
  UPDATE_INSTAGRAM_STATUS = 'INFLUENCERS/UPDATE_INSTAGRAM_STATUS',
}

export enum INFLUENCERS_LIST_ACTIONS {
  REQUEST_SAVED_LISTS = 'INFLUENCERS/REQUEST_SAVED_LISTS',
  RECEIVE_SAVED_LISTS = 'INFLUENCERS/RECEIVE_SAVED_LISTS',
  REQUEST_SAVED_LISTS_BY_USER = 'INFLUENCERS/REQUEST_SAVED_LISTS_BY_USER',
  RECEIVE_SAVED_LISTS_BY_USER = 'INFLUENCERS/RECEIVE_SAVED_LISTS_BY_USER',
  REQUEST_ADD_USER_TO_LIST = 'INFLUENCERS/REQUEST_ADD_USER_TO_LIST',
  RECEIVE_ADDED_USER_TO_LIST = 'INFLUENCERS/RECEIVE_ADDED_USER_TO_LIST',
  REQUEST_REMOVE_USER_FROM_LIST = 'INFLUENCERS/REQUEST_REMOVE_USER_FROM_LIST',
  RECEIVE_REMOVED_USER_FROM_LIST = 'INFLUENCERS/RECEIVE_REMOVED_USER_FROM_LIST',
  RECEIVE_ADDED_USER_TO_LIST_ERROR = 'INFLUENCERS/RECEIVE_ADDED_USER_TO_LIST_ERROR',
  REQUEST_CREATE_LIST = 'INFLUENCERS/REQUEST_CREATE_LIST',
  RECEIVE_CREATED_LIST = 'INFLUENCERS/RECEIVE_CREATED_LIST',
  CLEAR_CREATE_LIST = 'INFLUENCERS/CLEAR_CREATE_LIST',
  REQUEST_TRACKED_INFLUENCERS = 'INFLUENCERS/REQUEST_TRACKED_INFLUENCERS',
  RECEIVE_TRACKED_INFLUENCERS = 'INFLUENCERS/RECEIVE_TRACKED_INFLUENCERS',
  ADD_TRACKED_INFLUENCER = 'INFLUENCERS/ADD_TRACKED_INFLUENCER',
  UPDATE_TRACKED_INFLUENCERS = 'INFLUENCERS/UPDATE_TRACKED_INFLUENCERS',
  UPDATE_INFLUENCER_LISTS = 'INFLUENCERS/UPDATE_INFLUENCER_LISTS',
}

export const INFLUENCER_MEDIA_CARD_MEDIA_SIZE = 212;

export const SOURCE_TRACKING_LAG_MS = 90000; // 1.5 * 60 * 1000 = 1.5 minutes

export const INFLUENCERS_DELETE_LIST_WARNING = `Are you sure you would like to delete this list?
Creators will still be tracked and can be viewed in any other lists in which they've been added.`;

export const INFLUENCERS_UNTRACK_WARNING = `Deleting this creator from your
account will remove them from all Creator Lists, Collections, and Gallery streams. The
creator will no longer count towards your creator limit.`;

export const INFLUENCERS_OVER_LIMIT_WARNING = `You've reached your creator limit. Please reach out
to your Bazaarvoice representative to increase your limit, or consider removing some creators
to continue.`;

export const INFLUENCERS_BULK_ADD_STATUS: Record<
  IInfluencerBulkAddStatusCode,
  Omit<IInfluencersBulkAddStatus, 'statusCode'>
> = {
  BusinessUserAdded: {
    message: 'Successfully Added',
    isFailure: false,
  },
  NonBusinessUserAdded: {
    message: 'Successfully Added (Limited Tracking)',
    tooltip: `This user is a non-business account.
     As a result, you are only able to view and track their Instagram posts that mention or tag your brand.`,
    isFailure: false,
  },
  UserNotFound: {
    message: 'Creator not found',
    isFailure: true,
  },
  FailedToAddUser: {
    message: 'Failed',
    isFailure: true,
  },
  UserExists: {
    message: 'This creator is already in this list.',
    isFailure: true,
  },
  UserNotSupported: {
    message: "User's social network is not supported",
    isFailure: true,
  },
} as const;

export const CREATOR_STATS = {
  FOLLOWERS: 'FOLLOWERS',
  POSTS: 'POSTS',
  POSTS_FT_BRAND: 'POSTS FEAT. MY BRAND',
  FOLLOWER_ENG_RATE: 'FOLLOWER ENG. RATE',
  AVG_EMV: 'AVG. EMV',
  AVG_VIEWS: 'AVG. VIEWS',
};

export const INFLUENCERS_USER_CARD_STATS = {
  FOLLOWERS: 'FOLLOWERS',
  POSTS_FT_BRAND: 'POSTS FEAT. MY BRAND',
  FOLLOWER_ENG_RATE: 'FOLLOWER ENG. RATE',
  AVG_EMV: 'AVG. EMV',
};

export const CREATOR_STATS_TOOLTIPS = {
  POSTS_FT_BRAND:
    'The total number of posts that this creator has' +
    ' published mentioning or tagging your brand.',
  FOLLOWER_ENG_RATE:
    'This is the average Follower Engagement Rate across recent posts.' +
    ' Follower Engagement Rate is calculated by taking the likes plus comments of each' +
    ' post and dividing by followers.',
  AVG_EMV:
    'This is the average Earned Media Value across recent posts. Earned Media' +
    " Value is the estimated value of the impressions that this creator's posts have" +
    ' generated.',
};

export const INFLUENCERS_USER_CARD_STAT_TOOLTIPS = {
  POSTS_FT_BRAND:
    'The total number of posts that this creator has' +
    ' published mentioning or tagging your brand.',
  FOLLOWER_ENG_RATE:
    'This is the average Follower Engagement Rate across recent posts.' +
    ' Follower Engagement Rate is calculated by taking the likes plus comments of each' +
    ' post and dividing by followers.',
  AVG_EMV:
    'This is the average Earned Media Value across recent posts. Earned Media' +
    " Value is the estimated value of the impressions that this creator's posts have" +
    ' generated.',
};

export enum INFLUENCERS_LIST_MEDIA_SORT {
  LIKES = 'likes',
  TIME = 'time',
  COMMENTS = 'comments',
  EMV = 'emv',
  ENGAGEMENT = 'engagement',
}

export const INFLUENCER_MEDIA_CARD_ICONS = {
  COMMENTS: 'comments',
  ENGAGEMENT: 'multiple-users',
  EMV: 'emv',
  LIKES: 'likes',
  INSTAGRAM: 'instagram',
  VIDEO: 'instagram-video',
} as const;

export const INFLUENCER_MEDIA_CARD_STAT_TOOLTIPS = {
  ENGAGEMENT:
    'Follower Engagement Rate: The number of likes plus the number of ' +
    'comments divided by the number of current followers.',
  EMV: 'Earned Media Value: The estimated value of the impressions that this posts has generated.',
  LIKES: 'Likes: Number of times this post was liked.',
  COMMENTS: 'Comments: Number of comments this post received.',
  POSTS: 'Number of posts matching the current filters.',
};

export const INFLUENCER_STAT_BUBBLE_TITLES = {
  COMMENTS: 'Total Comments',
  EMV: 'Average EMV',
  ENGAGEMENT: 'Follower Eng. Rate',
  LIKES: 'Total Likes',
  POSTS: 'Total Posts',
};

export const INFLUENCER_STAT_BUBBLE_TOOLTIPS = {
  COMMENTS: 'Number of comments associated with the filtered set of media.',
  EMV: 'Average Earned Media Value per post in the filtered set of Instagram media.',
  ENGAGEMENT:
    'Average Engagement Rate of the posts in the filtered set of media.',
  LIKES: 'Number of likes associated with the filtered set of media.',
  POSTS: 'Number of posts matching the current filters.',
};

export const INFLUENCER_DETAILS_STAT_BUBBLE_TITLES = {
  AVG_COMMENTS: 'Average Comments',
  TOTAL_COMMENTS: 'Total Comments',
  EMV: 'Average EMV',
  ENGAGEMENT: 'Follower Engagement Rate',
  AVG_LIKES: 'Average Likes',
  TOTAL_LIKES: 'Total Likes',
};

export const INFLUENCER_DETAILS_STAT_BUBBLE_TOOLTIPS = {
  AVG_COMMENTS:
    'Average number of comments per post in the filtered set of media.',
  TOTAL_COMMENTS:
    'Number of comments associated with the filtered set of media.',
  EMV: 'Average Earned Media Value per post in the filtered set of media.',
  ENGAGEMENT:
    'Average Follower Engagement Rate of the posts in the filtered set of media.',
  AVG_LIKES: 'Average number of likes per post in the filtered set of media.',
  TOTAL_LIKES:
    'Total number of likes associated with the filtered set of media.',
};

export const INFLUENCER_SEARCH_LIMITS = {
  FOLLOWERS_LOWER: 2000,
  FOLLOWERS_UPPER: 1000000,
  ESTIMATED_ENGAGEMENT_RATE_LOWER: 0,
  ESTIMATED_ENGAGEMENT_RATE_UPPER: 5,
  TOTAL_POSTS_LOWER: 10,
  TOTAL_POSTS_UPPER: 2000,
};

export type InfluencersSortDir = 'asc' | 'desc';

export const INFLUENCER_TABLE_HEADERS = {
  SELECT_CREATOR_CHECKBOX: {
    title: 'SELECT CREATOR TO ADD TO ANOTHER LIST',
    helpText: undefined,
    helpTextTitle: undefined,
    sortType: undefined,
    trackingId: undefined,
  },
  INFLUENCER: {
    title: 'INFLUENCER',
    helpText: undefined,
    helpTextTitle: undefined,
    sortType: undefined,
    trackingId: undefined,
  },
  CREATOR: {
    title: 'CREATOR',
    helpText: undefined,
    helpTextTitle: undefined,
    sortType: undefined,
    trackingId: undefined,
  },
  FOLLOWERS: {
    title: 'FOLLOWERS',
    helpText: 'Total number of followers this creator has.',
    helpTextTitle: undefined,
    sortType: CreatorListSort.FOLLOWERS,
    trackingId:
      InfluencersTrackingIds.CREATOR_LISTS_USERS_TABLE_HEADER_SORT_FOLLOWERS,
  },
  POSTS_FT_BRAND: {
    title: 'POSTS FT. MY BRAND',
    helpText: `Total number of posts from this creator that your brand is mentioned or tagged in. This metric only applies to Instagram and TikTok.`,
    helpTextTitle: 'Posts Featuring My Brand',
    sortType: CreatorListSort.POSTS_FT_BRAND,
    trackingId:
      InfluencersTrackingIds.CREATOR_LISTS_USERS_TABLE_HEADER_SORT_POSTS_FT_BRAND,
  },
  FOLLOWER_ENG_RATE: {
    title: 'FOLLOWER ENG. RATE',
    helpText:
      'The number of likes plus the number of comments divided by the number of current followers this creator has.',
    helpTextTitle: 'Follower Engagement Rate',
    sortType: CreatorListSort.FOLLOWER_ENG_RATE,
    trackingId:
      InfluencersTrackingIds.CREATOR_LISTS_USERS_TABLE_HEADER_SORT_ENGAGEMENT_RATE,
  },
  AVG_EMV: {
    title: 'AVG. EMV',
    helpText: 'The estimated value that this creator is providing your brand.',
    helpTextTitle: 'Average Earned Media Value',
    sortType: CreatorListSort.AVG_EMV,
    trackingId:
      InfluencersTrackingIds.CREATOR_LISTS_USERS_TABLE_HEADER_SORT_AVG_EMV,
  },
} as const;

export const HARMONY_CREATOR_TABLE_HEADERS = {
  CREATOR: 'CREATOR',
  BIO: 'BIO',
  FOLLOWERS: 'FOLLOWERS',
  FOLLOWER_ENG_RATE: 'FOLLOWER ENG. RATE',
  ACTION: 'ACTION',
} as const;

export const HARMONY_SORT_ITEMS_NAME = {
  RELEVANCE: 'Relevance',
  FOLLOWERS: 'Highest Followers',
  ENGAGEMENT: 'Highest Follower Eng. Rate',
};

export const CREATOR_DEFAULT_USER_FETCH_COUNT = 16;

export const CREATOR_TABLE_USER_COUNT_OPTIONS = [8, 16, 32, 64];

export const CREATOR_LIST_EMPTY_TEXT = {
  EMPTY_SEARCH_AND_FILTERS:
    'There are no results that match your search and filters.',
  EMPTY_LIST:
    "Looks like you haven't added any Creators to this list yet. " +
    'Get started by Exploring Creators or manually adding Creators to this list.',
};

export const INFLUENCER_NETWORKS = {
  FACEBOOK: 'Facebook',
  INSTAGRAM: 'Instagram',
};

export type ProfileNetwork = Extract<
  SocialNetwork,
  'Instagram' | 'TikTok' | 'YouTube'
>;
export const PROFILE_NETWORKS_LIST: ProfileNetwork[] = [
  SocialNetwork.Instagram,
  SocialNetwork.TikTok,
  SocialNetwork.YouTube,
];

export type INFLUENCER_RIGHTS_SETTING = keyof typeof INFLUENCER_RIGHTS_SETTINGS;

export const INFLUENCER_RIGHTS_SETTINGS = {
  DEFAULT: 'Default',
  MENTIONED_AND_TAGGED: 'MentionedAndTagged',
  ALL_MEDIA: 'AllMedia',
};

export const INFLUENCER_RIGHTS_TEXT = {
  LIST: {
    CTA: 'Configure how rights are approved on media published by Influencers within this list.',
    CTA_IG_ONLY:
      'Configure how rights are approved on media published by Instagram Influencers within this list.',
    DEFAULT: {
      LABEL: 'Require Rights Requests on All Media',
      CAPTION:
        'By default, you will have to request rights on all media published by Influencers in this list. ' +
        "Select this option if you'd like to pick and choose which media you'd like to request rights on.",
    },
    MENTIONED_AND_TAGGED: {
      LABEL: 'Auto-approve Rights on Mentioned/Tagged Media',
      CAPTION:
        'You will automatically have rights approved for all media mentioning or tagging your brand that is ' +
        'published by Influencers in this list.',
    },
    ALL_MEDIA: {
      LABEL: 'Auto-approve Rights on All Media in this List',
      CAPTION:
        'You will automatically have rights approved for all media published by Influencers in this list.',
    },
  },
  DETAILS: {
    CTA: 'Configure how rights are approved on media published by this Influencer.',
    DEFAULT: {
      LABEL: 'Require Rights Requests on All Media',
      CAPTION:
        'By default, you will have to request rights on all media published by this Influencer. ' +
        "Select this option if you'd like to pick and choose which media you'd like to request rights on.",
    },
    MENTIONED_AND_TAGGED: {
      LABEL: 'Auto-approve Rights on Mentioned/Tagged Media',
      CAPTION:
        'You will automatically have rights approved for all media mentioning or tagging your brand that is ' +
        'published by this Influencer.',
    },
    ALL_MEDIA: {
      LABEL: 'Auto-approve Rights on All Media from this Influencer',
      CAPTION:
        'You will automatically have rights approved for all media published by this Influencer.',
    },
  },
};

export const INFLUENCER_RIGHTS_STATUSES = {
  SUCCESS: 'StatusSuccess',
};

export enum INFLUENCER_CONTENT_SOURCES {
  API = 'api',
  USS = 'uss',
}

export const HarmonyAiFilterNames = {
  HARMONY_AI_PLATFORM_FILTER: 'Platform',
  HARMONY_AI_GENDER_FILTER: 'Sex',
  HARMONY_AI_AGE_RANGE_FILTER: 'Age Range',
  HARMONY_AI_LOOKALIKES_FILTER: 'Find Similar',
  HARMONY_AI_BRANDS_FILTER: 'Brand Mentions',
  HARMONY_AI_LOCATIONS_FILTER: 'Location',
  HARMONY_AI_LANGUAGES_FILTER: 'Language',
  HARMONY_AI_FOLLOWER_ENGAGEMENT_RATE: 'Follower Eng. Rate',
  HARMONY_AI_FOLLOWER_COUNT_FILTER: 'Follower Count',
  HARMONY_AI_BIOGRAPHY_FILTER: 'Biography',
  HARMONY_AI_SOURCE_FILTER: 'Verification Source',
  HARMONY_AI_LAST_POSTED_AT_FILTER: 'Last Posted',
  HARMONY_AI_ADDITIONAL_FILTERS: 'Additional Filters',
} as const;

export const HARMONY_LAST_POSTED_DURATION_OPTIONS = [
  { days: 30, label: 'Last 30 days' },
  { days: 90, label: 'Last 3 months' },
  { days: 365, label: 'Last 1 year' },
];

export enum ListContentPlatformFilter {
  All = 'all',
  Instagram = 'instagram',
  TikTok = 'tiktok',
  YouTube = 'youtube',
}

export const CreatorDetailsInsightsInviteToRegisterText =
  'Invite this creator to register with Bazaarvoice to view';

export const BV_BADGE_TOOLTIP_TEXT =
  'These creators have authenticated their account with Bazaarvoice';

export const INFLUENSTER_PRO_BADGE_TOOLTIP_TEXT =
  'These creators have authenticated their account with InfluensterPro';

// Some features are only supported by some profile networks.
// This maps network support by feature
export const FEATURE_NETWORK_MAP = {
  ADULT_AUDIENCE_PERCENTAGE: [SocialNetwork.Instagram],
  CITY_DISTRIBUTION: [SocialNetwork.Instagram],
  AGE_GENDER_DISTRIBUTION: [SocialNetwork.Instagram],
  BRAND_AFFINITY: [SocialNetwork.Instagram],
  STORY_AVERAGE_ENGAGEMENT: [SocialNetwork.Instagram],
  AVERAGE_VIEWS: [SocialNetwork.TikTok],
  AVERAGE_SHARES: [SocialNetwork.TikTok],
  POSTS_FT_BRAND: [SocialNetwork.TikTok, SocialNetwork.Instagram],
  SIMILAR_CREATORS: [
    SocialNetwork.TikTok,
    SocialNetwork.Instagram,
    SocialNetwork.YouTube,
  ],
  INSIGHTS: [
    SocialNetwork.TikTok,
    SocialNetwork.Instagram,
    SocialNetwork.YouTube,
  ],
  FOLLOWERS_BY_LOCATION: [SocialNetwork.TikTok, SocialNetwork.Instagram],
};

export const INSTAGRAM_USERNAME_REGEX = /instagram\.com\/(.+?)(\/|$)/;
export const TIKTOK_USERNAME_REGEX = /tiktok\.com\/@(.+?)(\/|$)/;
export const YOUTUBE_USERNAME_REGEX = /youtube\.com\/@(.+?)(\/|$)/;
